<template>
  <div>
    <el-row class="search-title common-table-top" style="margin-top: 20px;padding-right: 0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button  type="primary" class="add-btn" style="margin-right: 32px" @click="downloadCustomer">导出</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
        :data="tableData"
        class="table">
        <el-table-column
          :label="item.label" v-for="(item, index) in headerList" :key="index" :prop="item.value">
           <template slot-scope="scope">
            <div v-if="item.label === '客户'" class="activity-name">
              <img :src="scope.row.avatar" class="heade-img">
              <div class="heade-nickname">{{ scope.row.nickname }}</div>
            </div>
            <div v-else>{{ scope.row[item.value] }}</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新建弹窗-->
      <el-dialog @close="closeNewSet" class="cellDialog base-dialog" title="分配场次" :visible.sync="QrcodeDialog" width="540px">
          <el-form label-position="right" :inline="true" :model="form" ref="form" :rules="rules" label-width="90px">
            <el-form-item label="活动类型:">
              <el-select filterable v-model="form.activity_id" placeholder="请选择活动类型">
                <el-option
                  v-for="item in activitiess"
                  :key="item.id"
                  :label="item.activity_name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场次名称:" prop="qrcode_name">
              <el-input v-model="form.qrcode_name" placeholder="请输入场次名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="业务员:" prop="saleman_id">
              <el-select v-model="form.salesman_id" placeholder="请选择业务员">
                <el-option
                  v-for="item in salesmanOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        <div slot="footer" class="dialog-footer" style="margin-top: 10px">
          <el-button class="dialog-cancel-btn" @click="QrcodeDialog = false">取 消</el-button>
          <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" :disabled="isDisabled" @click="submitForm('form')">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 二维码弹窗-->
      <el-dialog class="cellDialog base-dialog" title="二维码" :visible.sync="QRViewDialog" width="500px">
        <img :src="QRImage" style="width: 300px; height: 300px;">
      </el-dialog>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { exportFieldManage, getqrcodeActivityList, getStructureList, getSalesmanList, deleteActivityList, addActivityQrcode, getWeChatActivityListForFiled, getWechatPublicListForNode, getActivityStatics, exportFieldCanYU } from '@/api/customer.js'
export default {
  name: 'participants',
  data () {
    return {
      headerList: [],
      formInlineTmp: {},
      load: true,
      original_id: '',
      publicNumber: [],
      activities: [],
      timePickerDate: '',
      timeout: null,
      QrcodeDialog: false,
      QRViewDialog: false,
      isDisabled: false,
      QRImage: '',
      activity_id: 0,
      public_id: 0,
      addGradeForm: {
        grade: '',
        grade_list: []
      },
      addGradeDialog: false,
      formInline: {
        structure_id: '',
        public_id: '',
        nickname: '',
        activity_id: '',
        start_time: '',
        end_time: ''
      },
      form: {
        qrcode_name: '',
        activity_id: '',
        salesman_id: ''
      },
      qrcode_name: '',
      salesman_id: '',
      search: {
        keyword: '',
        qrcode_name: '',
        structure_name: ''
      },
      search_saleman: {
        public_id: ''
      },
      structureOptions: [],
      activitiess: [],
      salesmanOptions: [],
      hide: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      inGradeList: [],
      isSwitchClick: 1,
      rules: {
        qrcode_name: [
          { required: true, message: '请输入二维码名称', trigger: 'blur' }
        ],
        saleman_name: [
          { required: true, message: '请选择业务员', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    searchData() {
      if (this.timePickerDate === null) {
        this.formInlineTmp.start_time = ''
        this.formInlineTmp.end_time = ''
      } else {
        this.formInlineTmp.start_time = this.timePickerDate[0]
        this.formInlineTmp.end_time = this.timePickerDate[1]
      }
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.page = 1
      this.loadData()
    },
    // 关闭分配
    closeNewSet() {
      if (this.QrcodeDialog === false) {
        this.form.qrcode_name = ''
        this.form.activity_id = ''
        this.form.salesman_id = ''
      }
    },
    // 切换公众号
    getData() {
      this.search_saleman.public_id = this.formInline.public_id
      this.loadData()
    },
    // 请求公众号
    getWechatPublicListForNodes() {
      getWechatPublicListForNode(1).then(res => {
        for (let item of res.data.data.list) {
          if (item.is_default === 1) {
            this.formInline.public_id = item.id
          }
        }
        this.publicNumber = res.data.data.list
        this.search_saleman.public_id = this.formInline.public_id
        this.loadData()
      })
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.salesmanOptions
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants
    },
    createStateFilter(queryString) {
      return (state) => {
        return state.name.indexOf(queryString) !== -1
      }
    },
    handleSelect(item) {
    },
    // 判断开始结束时间大小
    verifyTime() {
      console.log(this.timePickerDate)
      if (this.timePickerDate === null) {
        return
      }
      if (Date.parse(new Date(this.timePickerDate[0])) === Date.parse(new Date(this.timePickerDate[1]))) {
        _g.toastMsg('error', '开始时间不能等于结束时间')
      }
    },
    addOfflineAcivityAction() {
      this.QrcodeDialog = true
    },
    deleteActivity(id) {
      this.$confirm('确认删除该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteActivityList(id).then(res => {
          if (res.data.code === 0) {
            _g.toastMsg('success', res.data.error)
            this.loadData()
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      })
    },
    toToTAL(Id, activity_id) {
      router.push({path: '/home/field-total', query: {id: Id, activity_id: activity_id}})
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.loadData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.loadData()
    },
    // 打开看二维码大图
    showQRcode(url) {
      this.QRViewDialog = true
      this.QRImage = url
    },
    // 导出
    downloadCustomer() {
      if (this.customerCount === 0) {
        _g.toastMsg('error', '没有数据可导出')
        return
      }
      let search = {}
      if (!this.hide) {
        search = this.allTerms
      } else {
        search = {
          allRelationship: 'or',
          termsGroup: [
            {
              inOperator: 'or',
              terms: [
                {
                  attr: 'attr',
                  secAttr: 'realname',
                  relationship: 'contain',
                  value: this.search.keywords
                },
                {
                  attr: 'attr',
                  secAttr: 'nickname',
                  relationship: 'contain',
                  value: this.search.keywords
                },
                {
                  attr: 'attr',
                  secAttr: 'mobile',
                  relationship: 'contain',
                  value: this.search.keywords
                }
              ]
            }
          ]
        }
      }
      let id = this.$route.query.id
      exportFieldCanYU(id).then(response => {
        this.download(response)
      }).catch((error) => {
        _g.toastMsg('error', error)
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 获取部门数据
    getStructureData() {
      getStructureList().then(res => {
        this.structureOptions.push({
          id: '',
          name: '全部'
        })
        for (let item of res.data.data.list) {
          this.structureOptions.push({
            id: item.id,
            name: item.name
          })
        }
      })
    },
    // 获取业务员
    getSalesmanData() {
      this.search_saleman.public_id = this.formInline.public_id
      getSalesmanList(1, this.search_saleman).then(res => {
        for (let item of res.data.data.list) {
          item.name = item.realname
        }
        this.salesmanOptions = res.data.data.list
      })
    },
    // 获取活动类型
    getWeChatActivityListForFileds(page) {
      this.search_saleman.public_id = this.formInline.public_id
      getWeChatActivityListForFiled(1, '', this.search_saleman.public_id).then(res => {
        res.data.data.list.unshift({ id: '', activity_name: '全部' })
        this.activities = res.data.data.list
      })
    },
    // 获取活动类型（非全部）
    getWeChatActivityListForFiledss(page) {
      this.search_saleman.public_id = this.formInline.public_id
      getWeChatActivityListForFiled(1, '', this.search_saleman.public_id).then(res => {
        this.activitiess = res.data.data.list
      })
    },
    // 新建弹窗提交
    submitForm() {
      if (this.form.activity_id === '') {
        _g.toastMsg('error', '请选择活动类型')
        return
      }
      if (this.form.qrcode_name === '') {
        _g.toastMsg('error', '请输入场次名称')
        return
      }
      if (this.form.salesman_id === '') {
        _g.toastMsg('error', '请选择业务员')
        return
      }
      this.QrcodeDialog = false
      addActivityQrcode(this.form.qrcode_name, this.form.salesman_id, this.form.activity_id).then(res => {
        if (res.data.code === 0) {
          this.QrcodeDialog = false
          this.isDisabled = false
          this.form.qrcode_name = ''
          this.form.salesman_id = ''
          _g.toastMsg('success', res.data.error)
        } else {
          this.isDisabled = false
          _g.toastMsg('error', res.data.error)
        }
        this.loadData()
      })
    },
    // 列表数据
    loadData() {
      this.load = true
      // 获取场次列表数据
      // this.formInline.start_time = this.timePickerDate[0]
      // this.formInline.end_time = this.timePickerDate[1]
      let id = this.$route.query.id
      let modelId = this.model_id
      let getqrcodeActivityLists = getActivityStatics(id, modelId, this.page)
      // 获取业务员
      let getSalesmanDatas = getSalesmanList(1, this.search_saleman)
      // 获取活动类型
      let getWeChatActivityListForFiledsa = getWeChatActivityListForFiled(1, '', this.search_saleman.public_id)
      // 获取活动类型无全部
      let getWeChatActivityListForFiledssb = getWeChatActivityListForFiled(1, '', this.search_saleman.public_id)
      // 发送promiss请求并处理
      Promise.all([getqrcodeActivityLists, getSalesmanDatas, getWeChatActivityListForFiledsa, getWeChatActivityListForFiledssb]).then(res => {
        // 获取场次列表
        if (res[0].data.code === 0) {
          this.totalCount = res[0].data.data.total
          this.tableData = res[0].data.data.list
          this.headerList = res[0].data.data.title
          console.log(this.headerList)
          this.headerList.splice(0, 1)
          console.log('headerList', this.headerList)
        }
        // 业务员列表
        if (res[1].data.code === 0) {
          for (let item of res[1].data.data.list) {
            item.name = item.realname
          }
          this.salesmanOptions = res[1].data.data.list
        }
        // 获取活动类型列表查询
        if (res[2].data.code === 0) {
          res[2].data.data.list.unshift({ id: '', activity_name: '全部' })
          this.activities = res[2].data.data.list
        }
        // 获取活动类型弹窗
        if (res[3].data.code === 0) {
          this.activitiess = res[3].data.data.list
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.load = false
      }, 500)
    }
  },
  created() {
    this.loading = true
    let limit_salesman = 0
    this.model_id = this.$route.query.model_id
    this.activity_id = this.$route.query.id
    this.formInline.activity_id = this.$route.query.id
    this.getStructureData()
    this.getWechatPublicListForNodes()
  }
}
</script>

<style scoped>
.heade-img {
  width: 40px;
  height: 40px;
  border-radius: 20px;
}
.activity-name {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.heade-nickname {
  margin-left: 10px;
  margin-top: 10px;
}
</style>
